//Import React
import React, { useCallback, useContext, useEffect, useState } from "react";
//Imports Contexts
import { AppContext } from "../../../../contexts/AppContext";
import { AuthContext } from "../../../../contexts/AuthContext";
//Imports Components
import ContainerSearchPMEReport from '../reportsPME/ContainerSearchReport';
import ReportsBudget from "./ReportsBudget";
//Imports CSS
import './budget.css';

function BudgetExecution() {
    const { dataProjects, establishmentList, pmeList } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    const [pme, setPme] = useState(null);
    const [view, setView] = useState(false);
    const [selectedYear, setSelectedYear] = useState(null);
    const [showReport, setShowReport] = useState(false);
    const [dataSearch, setDataSearch] = useState({
        region: null,
        commune: null,
        holder: { value: null, id: null },
        establishment: { value: null, id: null },
    });

    const isAdmin = userData?.permissions === 'admin';
    const isHolder = userData?.dimension === 'Sostenedor';
    const isEstablishment = userData?.dimension === 'Establecimiento';

    //UseEffect y useCallback
    const updatePMEData = useCallback(() => {
        if (!pmeList || !establishmentList) return;

        if (isEstablishment) {
            //Usuario establecimiento: Mostrar solo sus PMEs.
            const establishmentPMEs = pmeList.filter(pme =>
                pme.establishmentId === userData.establishmentId
            );
            if (establishmentPMEs.length > 0) {
                setPme(establishmentPMEs);
                setView(true);
            }
        } else if (isHolder) {
            const establishments = establishmentList.filter(est => est.projectId === userData?.tenantId);
            const holderPMEs = pmeList.filter(pme =>
                establishments.some(est => est.id === pme.establishmentId)
            );
            if (holderPMEs.length > 0) {
                setPme(holderPMEs);
                setView(true);
            }
        } else if (isAdmin) {
            if (dataSearch.holder.id) {
                const establishments = establishmentList.filter(est => est.projectId === dataSearch.holder.id);
                const holderPMEs = pmeList.filter(pme =>
                    establishments.some(est => est.id === pme.establishmentId)
                );
                if (holderPMEs.length > 0) {
                    setPme(holderPMEs);
                    setView(true);
                }
            }
        }
    }, [pmeList, establishmentList, userData, dataSearch?.holder?.id, isEstablishment, isHolder]);

    useEffect(() => {
        if (isHolder || isEstablishment) {
            updatePMEData();
        }
    }, [updatePMEData, isHolder, isEstablishment]);

    //Manejadores de eventos
    const handleSelect = (selectedOption, { name }) => {
        const value = selectedOption ? selectedOption.value : null;
        const id = selectedOption ? selectedOption.id : null;

        setDataSearch(prevState => ({
            ...prevState,
            [name]: name === 'holder'
                ? { value, id }
                : value,
            ...(name === 'region' && { commune: null, holder: { value: null, id: null }, establishment: null }),
            ...(name === 'commune' && { holder: { value: null, id: null }, establishment: null }),
            ...(name === 'holder' && { establishment: null })
        }));
        setView(false);
        setSelectedYear(null);
    };
    const handleButtonClick = () => {
        updatePMEData()
    };
    const handleYearSelect = (year) => {
        setSelectedYear(year);
        setShowReport(true);
    };
    return (
        <section className='budget-execution-report flex'>
            {isAdmin && (
                <ContainerSearchPMEReport
                    dataSearch={dataSearch}
                    setDataSearch={setDataSearch}
                    handleSelect={handleSelect}
                    handleButtonClick={handleButtonClick}
                    dataProjects={dataProjects}
                    establishmentList={establishmentList}
                />
            )}
            <section className='report-container flex'>
                {(view && pme) ? (
                    <>
                        <h3>Informes Ejecución Presupuestaria</h3>
                        <p>Selecciona un año de PME para ver informe</p>
                        <article className='report-box flex'>
                            {pme
                                .map(item => item.yearPME)
                                .filter((year, index, self) => self.indexOf(year) === index)
                                .sort((a, b) => b - a)
                                .map(year => (
                                    <span key={year} className='report flex' onClick={() => handleYearSelect(year)}>
                                        <p>Reportes para PME:</p>
                                        <p><strong>{year}</strong></p>
                                    </span>
                                ))
                            }
                        </article>
                    </>
                ) : (
                    <p className='text-bold message-not-found flex'>
                        {isEstablishment
                            ? 'No existen PMEs para este establecimiento'
                            : isHolder
                                ? 'No existen PMEs para los establecimientos a cargo'
                                : 'Seleccione un sostenedor para ver los PMEs'
                        }
                    </p>
                )}
            </section>
            {showReport && (
                <ReportsBudget 
                    pme={pme}
                    onClose={setShowReport}
                    yearSelected={selectedYear}
                    establishmentList={establishmentList}
                    pmeList={pmeList}
                    isAdmin={isAdmin}
                    isHolder={isHolder}
                    userData={userData}
                    dataSearch={dataSearch}
                />
            )}
        </section>
    );
};

export default BudgetExecution